import { render, staticRenderFns } from "./MenuLayout.vue?vue&type=template&id=44d138ca&"
import script from "./MenuLayout.vue?vue&type=script&lang=js&"
export * from "./MenuLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports